// extracted by mini-css-extract-plugin
export default {"blocks":"InfoGraphic_blocks__Jb+qK","block":"InfoGraphic_block__meQUg","image":"InfoGraphic_image__oV4BQ","title":"InfoGraphic_title__Ucljc","text":"InfoGraphic_text__2qjT+"};